import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as pricingActions from '../../redux/actions/pricing';
import MetaPanel from './components/MetaPanel';
import TableLoader from '../../components/TableLoader';
import { fetchEventStats, fetchSBEventMeta } from '../../services/killshot';

const eventMetaSelector = (eventMetas, eventStats) => ({
  ...eventMetas,
  sb_stats: {
    quantity_purchased: eventStats.total_num_purchased || 0,
    quantity_held: eventStats.total_num_held || 0,
    quantity_sold: eventStats.total_num_sold || 0,
    one_day_pace: eventStats.sb_one_day_pace || '0.00',
    three_day_pace: eventStats.sb_three_day_pace || '0.00',
    seven_day_pace: eventStats.sb_seven_day_pace || '0.00',
    thirty_day_pace: eventStats.sb_thirty_day_pace || '0.00',
  },
  tickets_needed_to_sell_per_day: eventStats.tickets_needed_to_sell_per_day,
  currency: eventMetas.currency,
});

const MetaPanelContainer = ({ eventMeta, eventId, skyboxId, forceUpdate, setRefresh, typeListing }) => {
  const [isLoading, setLoading] = useState(false);
  const [eventStats, setEventStats] = useState({});
  const [SBEventMeta, setSBEventMeta] = useState({});

  const useFetch = props => {
    useEffect(() => {
      const fetchData = async () => {
        try {
          setLoading(true);
          const responseEventStats = await fetchEventStats(props.eventId);
          const response = await fetchSBEventMeta(props.skyboxId);
          setEventStats(responseEventStats.response);
          setSBEventMeta(response.response);

          setLoading(false);
        } catch (e) {
          // setError(e);
        }
      };

      if (props.eventId && props.skyboxId) {
        fetchData();
      }
    }, [props.skyboxId, props.eventId, props.forceUpdate]);
  };

  useFetch({ eventId, skyboxId, forceUpdate });

  if (isLoading) {
    return <TableLoader />;
  }

  return (
    <MetaPanel
      eventMeta={eventMetaSelector(eventMeta, eventStats)}
      SBEventMeta={SBEventMeta}
      eventId={eventId}
      setRefresh={setRefresh}
      marketplace={typeListing}
    />
  );
};

MetaPanelContainer.propTypes = {
  eventId: PropTypes.any.isRequired,
  skyboxId: PropTypes.number.isRequired,
  eventMeta: PropTypes.object.isRequired,
  forceUpdate: PropTypes.number.isRequired,
  setRefresh: PropTypes.func.isRequired,
  typeListing: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    eventMeta: state.pricing.eventMeta,
    typeListing: state.pricing.typeListing,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(pricingActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MetaPanelContainer);
